/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import 'echarts/lib/chart/heatmap';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/visualMap';
import echarts from 'echarts/lib/echarts';
import { connect } from 'react-redux';
import styles from './styles.scss';


const defaultProps = {
  legend: [],
  grid: null,
  xAxis: null,
  yAxis: null,
  dataZoom: null,
  tooltip: {},
  resize: null,
  collapsed: false,
  visualMap: null,
  colorShift: 0,
  height: $(window).height() / 2,
  width: '100%',
  clickFn: () => {},
};

const propTypes = {
  series: PropTypes.array.isRequired,
  legend: PropTypes.any,
  grid: PropTypes.any,
  xAxis: PropTypes.any,
  yAxis: PropTypes.any,
  visualMap: PropTypes.any,
  tooltip: PropTypes.object,
  colorShift: PropTypes.number,
  clickFn: PropTypes.func,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class HeatmapChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      series: props.series,
      legend: props.legend,
      width: props.width,
      height: props.height,
    };
    this.tryResizeChart = this.tryResizeChart.bind(this);
  }

  componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  }

  componentWillReceiveProps(nextProps) {
    const { series, legend, xAxis, yAxis, tooltip, width, height } = nextProps;
    if (width !== this.props.width) {
      this.setState({ width }, this.tryResizeChart);
    }
    if (height !== this.props.height) {
      this.setState({ height }, this.tryResizeChart);
    }
    if (!_.isEqual(series, this.props.series)) {
      this.updateChart(series, legend, xAxis, yAxis, tooltip);
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend,
      });
    }
    this.tryResizeChart();
  }

  componentWillUnmount() {
    echarts.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  }

  colors() {
    const { colorShift } = this.props;
    if (colorShift > 0) {
      return _.concat(
        _.drop(HeatmapChart.colors, colorShift),
        _.take(HeatmapChart.colors, colorShift),
      );
    }
    return HeatmapChart.colors;
  }

  tryResizeChart() {
    const width = $(this.chartRef).width();
    const height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  }

  updateChart(nextSeries, nextLegend, xAxis, yAxis, tooltip) {
    const { series: thisSeries } = this.state;
    const series = nextSeries.map(s => (
      _.extend({
        type: 'heatmap',
      }, s)
    ));
    const legend = nextLegend || [];
    const option = {
      ...this.echart.getOption(),
      xAxis,
      yAxis,
      series,
      legend,
      tooltip,
    };
    if (!_.isEqual(
          _.map(thisSeries, 'name'),
          _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  }

  initChart() {
    const echart = echarts.init(this.chartRef);
    const series = this.state.series.map(s => ({
      name: s.name,
      data: s.data,
      type: 'heatmap',
    }));

    const { legend, grid, visualMap, tooltip, xAxis, yAxis } = this.props;
    const option = {
      xAxis,
      yAxis,
      legend,
      series,
      visualMap,
      grid,
      color: this.colors(),
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
      },
      tooltip: {
        ...tooltip,
      },
      animationEasing: 'cubicIn',
      showLoading: true,
    };
    echart.setOption(option);
    echart.on('click', this.props.clickFn);
    return echart;
  }

  render() {
    const { height, width } = this.state;
    return (
      <div
        className={styles.chart}
        style={{ width, height }}
        ref={(ref) => { this.chartRef = ref; }}
      />
    );
  }
}

HeatmapChart.colors = [
  '#22A7F0',
  '#00B16A',
  '#F7CA18',
  '#F9690E',
  '#EF4836',
  '#DB0A5B',
  '#663399',
  '#BF55EC',
  '#446CB3',
  '#336E7B',
  '#1BBC9B',
];
HeatmapChart.propTypes = propTypes;
HeatmapChart.defaultProps = defaultProps;

const mapStateToProps = state => ({
  collapsed: state.sidebar.collapsed,
});

export default connect(mapStateToProps, null)(HeatmapChart);




// WEBPACK FOOTER //
// ./src/components/HeatmapChart/index.jsx